export default __webpack_public_path__ + "locales/si/People.json?hash=bf3c168f07ffc1bbfade50745e7d3ac1";